import script from "./Congratulations.vue?vue&type=script&setup=true&lang=js"
export * from "./Congratulations.vue?vue&type=script&setup=true&lang=js"

import "./Congratulations.vue?vue&type=style&index=0&id=458d1d06&lang=css"

const __exports__ = script;

export default __exports__